import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "@/components/Reveal";

const Block = ({ title, children, testid }) => (
  <Reveal>
    <div className="bg-[#111318] border border-white/10 rounded-md p-7 sm:p-9" data-testid={testid}>
      <h2 className="font-display text-2xl sm:text-3xl font-bold uppercase text-[#FFE600] mb-4">{title}</h2>
      <div className="text-gray-300 text-sm sm:text-base leading-relaxed space-y-3">{children}</div>
    </div>
  </Reveal>
);

const Datenschutz = () => (
  <div data-testid="datenschutz-page">
    <section className="bg-blueprint pt-40 pb-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <SectionLabel>Rechtliches</SectionLabel>
          <h1 className="mt-5 font-display text-5xl sm:text-7xl font-extrabold uppercase text-white leading-[0.9]">
            Daten<span className="text-[#FFE600]">schutz</span>erklärung
          </h1>
        </motion.div>
      </div>
    </section>

    <section className="pb-24 pt-4">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
        <Block title="1. Allgemeine Hinweise" testid="privacy-block-1">
          <p>
            Der Schutz Ihrer persönlichen Daten ist uns wichtig. Wir behandeln
            Ihre personenbezogenen Daten vertraulich und entsprechend der
            gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
          </p>
          <p>
            Die Nutzung unserer Website ist in der Regel ohne Angabe
            personenbezogener Daten möglich.
          </p>
        </Block>

        <Block title="2. Verantwortlicher" testid="privacy-block-2">
          <p>
            HeroPhone
            <br />
            Ricardo Galindo Cuenca
            <br />
            Dorfstraße 70A
            <br />
            21775 Odisheim
          </p>
          <p>
            E-Mail: info@hero-phone.de
            <br />
            Telefon: 0151 16012024
          </p>
        </Block>

        <Block title="3. Server-Log-Dateien" testid="privacy-block-3">
          <p>
            Der Provider der Seiten erhebt und speichert automatisch Informationen
            in sogenannten Server-Log-Dateien. Dies sind zum Beispiel:
          </p>
          <ul className="list-disc list-inside space-y-1 text-gray-400">
            <li>Browsertyp</li>
            <li>Betriebssystem</li>
            <li>Referrer URL</li>
            <li>Hostname des zugreifenden Rechners</li>
            <li>Uhrzeit der Serveranfrage</li>
            <li>IP-Adresse</li>
          </ul>
          <p>Diese Daten sind nicht bestimmten Personen zuordenbar.</p>
        </Block>

        <Block title="4. Kontaktaufnahme" testid="privacy-block-4">
          <p>
            Wenn Sie uns per E-Mail oder Kontaktformular Anfragen zukommen lassen,
            werden Ihre Angaben zur Bearbeitung der Anfrage gespeichert.
          </p>
          <p>Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
        </Block>

        <Block title="5. Ihre Rechte" testid="privacy-block-5">
          <p>Sie haben jederzeit das Recht auf:</p>
          <ul className="list-disc list-inside space-y-1 text-gray-400">
            <li>Auskunft über Ihre gespeicherten Daten</li>
            <li>Berichtigung</li>
            <li>Löschung</li>
            <li>Einschränkung der Verarbeitung</li>
            <li>Widerspruch gegen die Verarbeitung</li>
          </ul>
        </Block>

        <Block title="6. SSL-Verschlüsselung" testid="privacy-block-6">
          <p>Diese Seite nutzt aus Sicherheitsgründen eine SSL-Verschlüsselung.</p>
          <p>
            Eine verschlüsselte Verbindung erkennen Sie daran, dass die
            Adresszeile des Browsers von http:// auf https:// wechselt.
          </p>
        </Block>
      </div>
    </section>
  </div>
);

export default Datenschutz;
